<template>
  <div class="main">
    <div class="pageTitle">
     <p>设置</p>
    </div>
    <div class="searchArea">
      <el-row :gutter="0">
          <el-col :span="10">
             <el-form :model="settingsModel" label-width="130px" size="small" label-position="left">
              <el-form-item label="周报补填：">
                <el-select v-model="settingsModel.weeklyReportPostCondition">
                  <el-option key="0" label="不限" :value="0"></el-option>
                  <el-option key="1" label="只允许填写本周" :value="1"></el-option>
                  <el-option key="2" label="只允许填写本周（但允许在下周一补填）" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-button size="small" @click="submitForm()" style="margin-left: 0;">保存</el-button>
            </el-form>
          </el-col>
          <el-col :span="14">
                
          </el-col>
       </el-row> 
      

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      settingsModel: {
        weeklyReportPostCondition:0
      }
    };
  },
  mounted(){
      this.getSettings();
  },
  methods: {
    getSettings() {this.$domainApi.getSettings()
        .then(res => {
          if (res.data.successful) {
            this.settingsModel = res.data.data;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },
    submitForm() {
      
      this.$domainApi.updateSettings(this.settingsModel)
          .then(res => {
            if (res.data.successful) 
            {
              this.$message(
              {
                message: "保存成功",
                type: "success",
                customClass: "successMsg",
                duration: 2000
              });

              this.$userContext.updateSettings(this.settingsModel);
            }
            else
            {
              this.$alert(res.data.message, "提示");
            }
          })
         ;
      
    },
    resetForm() {
      this.$refs["settingsModel"].resetFields();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/setting/settings.vue